export const forceDarkMode = () => {
  const htmlTag = document.documentElement
  htmlTag.setAttribute('class', 'dark')
  htmlTag.setAttribute('data-mode', 'dark')
}
